import React from 'react';

export const IconSearch =() => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="18.414" height="18.414" viewBox="0 0 18.414 18.414"><g transform="translate(1 1)"><circle cx="7" cy="7" r="7" fill="none" stroke="#9ca3af" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/><line x1="4" y1="4" transform="translate(12 12)" fill="none" stroke="#9ca3af" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/></g></svg>;
}